import type { LifecyclePrivacyRow } from '../../datagovernance/framework';

type Props = { items?: LifecyclePrivacyRow[] };

export function DataLifecyclePrivacyPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.area}-${item.policy}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-xs text-slate-400">{item.area}</p>
            <span className="shrink-0 rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300">
              {item.status}
            </span>
          </div>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">{item.policy}</p>
        </div>
      ))}
    </div>
  );
}
